import styled from 'components/_UI/designSystem';
import { Flexbox, getPx } from 'components/spaceKit';
export const StyledInput = styled(Flexbox)`
    width: 54px;
    min-width: 54px;
    max-width: 54px;
    > div {
        height: 40px;
    }
`;

export const StyledMetricCondition = styled.div`
    display: grid;
    grid-template-columns: 1fr max-content 1fr min-content;
    gap: ${getPx(2)};
`;

export const StyledDimensionCondition = styled(StyledMetricCondition)`
    grid-template-columns: 1fr 1fr min-content;
    row-gap: ${getPx(1)};
`;
